import React from 'react'
import PropTypes from 'prop-types'
import Moment from 'moment'

import Typography from '@eig-builder/core-ui/Typography'

import PartnerLogo from '../../../helpers/partner-logo'

import Text from '@eig-builder/module-localization'

const PartnerInfo = ({ account }) => {
  const singlePlatformCustomer = account.accountType === 2
  const constantContactCustomer = account.accountType === 3
  const migratedDate = Moment.utc(account.migratedDate).format('MM-DD-YYYY')

  return (
    <>
      <PartnerLogo partnerId={account.partnerId} partnerName={account.partnerName} />
      <div>
        {singlePlatformCustomer && <Text message='modules.crm.components.account.singlePlatformCustomer' />}
        {constantContactCustomer && <Text message='modules.crm.components.account.constantContactCustomer' />}
      </div>
      <div>
        {account.oldPartnerName && account.partnerId === 7 && (
          <Typography variant='subtitle2'>
            <Text message='modules.crm.components.account.migrated' values={[migratedDate]} />
          </Typography>
        )}
        {account.oldPartnerName && account.partnerId !== 7 && (
          <Typography variant='subtitle2'>
            <Text
              message='modules.crm.components.account.migratedFrom'
              values={[account.oldPartnerName, migratedDate]}
            />
          </Typography>
        )}
      </div>
      <div>
        {account.oldPartnerName && account.acceptedTerms && (
          <Typography variant='subtitle2'>
            <Text
              message='modules.crm.components.account.acceptedTerms'
              values={[Moment.utc(account.acceptedTerms).format('MM-DD-YYYY')]}
            />
          </Typography>
        )}
      </div>
    </>
  )
}

PartnerInfo.propTypes = {
  account: PropTypes.object.isRequired
}

export default PartnerInfo
